import { NgModule } from '@angular/core'
import { RouterModule, Routes } from '@angular/router'
import { msalLoginGuard } from './guards/msal-login.guard'
import { roleGuard } from './guards/role.guard'

const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'legacy/design',
  },
  {
    path: 'login',
    loadChildren: () => import('./login/login.module').then((m) => m.LoginModule),
  },
  {
    path: 'access-denied',
    loadChildren: () =>
      import('./access-denied/access-denied.module').then((m) => m.AccessDeniedModule),
  },
  {
    path: 'legacy',
    loadChildren: () => import('./legacy/legacy.module').then((m) => m.LegacyModule),
    canActivate: [msalLoginGuard, roleGuard],
  },
  {
    path: 'dashboard',
    loadChildren: () => import('./dashboard/dashboard.module').then((m) => m.DashboardModule),
    canActivate: [msalLoginGuard, roleGuard],
  },
  {
    path: 'reserve-analysis',
    loadChildren: () =>
      import('./reserve-analysis/reserve-analysis.module').then((m) => m.ReserveAnalysisModule),
    canActivate: [msalLoginGuard, roleGuard],
  },
  {
    path: 'reserving',
    loadChildren: () => import('./reserving/reserving.module').then((m) => m.ReservingModule),
  },
  {
    path: '**',
    redirectTo: 'legacy/design',
  },
]

@NgModule({
  imports: [RouterModule.forRoot(routes, { enableTracing: false })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
